import {HttpParams} from "@angular/common/http";
import {from, Observable} from "rxjs";
import {switchMap} from "rxjs/operators";
import {Page} from "../../utils/page";
import {
    RxdbOfflineEquoteOpportunityRepository
} from "../../rxdb/repositories/opportunities/offline-equote-opportunity.repository";
import {OpportunityV3ManagerService} from "../opportunity-v3-manager.service";
import {Opportunity} from "../../models/opportunity/opportunity.model";


export class OfflineOpportunityManagerService extends OpportunityV3ManagerService {

    constructor( protected rxdbOfflineEquoteOpportunityRepository: RxdbOfflineEquoteOpportunityRepository) {
        super(null as any);
    }

    getOpportunitiesWithQuotes(pageable: Map<string, string>, filters: Map<string, string>): Observable<Page<Opportunity>> {
        let params = new HttpParams();
        pageable.forEach((value, key) => params = params.set(key, value));
        filters.forEach((value, key) => params = params.set(key, value));

        return from(this.rxdbOfflineEquoteOpportunityRepository.getOpportunitiesWithQuotes(pageable, filters));
    }

    public updateOpportunityMainQuote(mainQuoteOfflineId: string, opportunityOfflineId: any): Observable<Opportunity> {
        return from(
            this.rxdbOfflineEquoteOpportunityRepository.getOpportunityByOfflineId(opportunityOfflineId)
        ).pipe(
            switchMap((opportunity: Opportunity) => {
                opportunity.mainQuoteOfflineId = mainQuoteOfflineId ?? null;
                return from(this.rxdbOfflineEquoteOpportunityRepository.updateOpportunity(opportunity));
            })
        );
    }

    public updateOpportunityStatus(status: string, opportunityId: number | string): Observable<Opportunity> {
        return from(
            this.rxdbOfflineEquoteOpportunityRepository.getOpportunityByOfflineId(String(opportunityId))
        ).pipe(
            switchMap((opportunity: Opportunity) => {
                opportunity.status = status as any;
                return from(this.rxdbOfflineEquoteOpportunityRepository.updateOpportunity(opportunity));
            })
        );
    }


    public saveOpportunity(opportunity: any): Observable<any> {
        if (!opportunity.offlineId) {
            return from(this.rxdbOfflineEquoteOpportunityRepository.createOpportunity(opportunity));
        }
        return from(this.rxdbOfflineEquoteOpportunityRepository.updateOpportunity(opportunity));

    }

    public watchOpportunityChanges(): Observable<any> {
        return this.rxdbOfflineEquoteOpportunityRepository.watchOpportunityChanges();
    }
}
